"use client";
import { CategoryTypeUploadEnum, IUploadFile } from "@/models";
import { ReactNode, useCallback } from "react";
import {
  Control,
  RegisterOptions,
  UseFormSetValue,
  UseFormTrigger,
  useWatch,
} from "react-hook-form";
import CoverImageControl, { CoverImageControlProps } from "./CoverImageControl";
import { InputLabelProps } from "@mui/material";

const AppFormControlUploadImage = ({
  control,
  trigger,
  onSetValueForm,
  name,
  onUploadSuccessFormCallback,
  label = "Ảnh",
  rules,
  coverImageControlProps,
  labelProps,
  helper,
  categoryType,
  ownerId = "",
}: {
  control: Control<any>;
  trigger: UseFormTrigger<any>;
  onSetValueForm: UseFormSetValue<any>;
  onUploadSuccessFormCallback?: (file?: IUploadFile) => void;
  name: string;
  label?: ReactNode;
  rules?: RegisterOptions;
  coverImageControlProps?: Omit<
    CoverImageControlProps,
    | "name"
    | "onClearImageCover"
    | "control"
    | "onUploadThumb"
    | "imgSrc"
    | "categoryType"
    | "ownerId"
  >;
  labelProps?: InputLabelProps;
  helper?: string | ReactNode;
  categoryType: CategoryTypeUploadEnum;
  ownerId?: string;
}) => {
  const watchFieldUrl = useWatch({
    control,
    name: name,
  });
  const handleUploadThumb = useCallback(
    async (acceptedFiles: Array<IUploadFile>) => {
      if (acceptedFiles.length) {
        const file = acceptedFiles[0];
        onSetValueForm(name, file.link, {
          shouldValidate: true,
        });
        if (typeof onUploadSuccessFormCallback === "function") {
          onUploadSuccessFormCallback(file);
        }
      }
    },
    [onSetValueForm]
  );
  const handleClearImageCover = () => {
    onSetValueForm(name, "", {
      shouldValidate: true,
    });
    if (typeof onUploadSuccessFormCallback === "function") {
      onUploadSuccessFormCallback();
    }
  };
  return (
    <CoverImageControl
      classNameContainer="w-full"
      label={label}
      rules={rules}
      name={name}
      control={control}
      onClearImageCover={handleClearImageCover}
      onUploadThumb={handleUploadThumb}
      imgSrc={watchFieldUrl}
      labelProps={labelProps}
      // imageSx={{
      //   // width: "unset",
      //   maxWidth: "100%",
      //   height: 330,
      //   maxHeight: "unset",
      // }}
      helper={helper}
      categoryType={categoryType}
      ownerId={ownerId}
      {...coverImageControlProps}
    />
  );
};

export default AppFormControlUploadImage;
